import React from "react";
import { LoginSignUp } from "@trodly/login-signup";
import Enquiry from "@trodly/lms";

import { API_ROOT, checkStatus, parseJSON } from "../constants";
import ContentLoader from "./loader";

class EnquiryMount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      userID: null
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    fetch(`${API_ROOT}getUser.php`, {
      credentials: "same-origin"
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        if (data.status) {
          this.setState({ userID: data.userData.uid });
        }
        this.setState({ loading: false });
      })
      .catch(err => console.log(err));
  }

  setUserID = userID => {
    this.setState({ userID });
  };

  render() {
    const { loading, userID } = this.state;
    const { activity, location } = this.props;
    if (loading) {
      return <ContentLoader />;
    }

    if (!userID) {
      return <LoginSignUp onSuccess={this.setUserID} />;
    }

    return <Enquiry userID={userID} activity={activity} location={location} />;
  }
}

export default EnquiryMount;
